import { ReactEditor } from 'slate-react';

import {
  focusEditor,
  insertBankMessage,
  insertExternalChannelItems,
  insertFileTextToPrompt,
  insertInstruction,
  insertResourceUrl,
  insertVariable,
  PROMPT_NODE_ID,
  removeNodeFromPromptById,
  removePrefixBeforeCaret,
} from 'src/components/RichSlate';
import { RESOURCE_CONTENT_TYPE } from 'src/data/performance';
import { editorHasValidSelection, SLATE_TEXT_FORMATS } from 'src/lib/slate';

/**
 * Insert "brief" line into the editor
 * @param editor
 * @param data
 */
export const actionInsertBrandBrief = (editor, data) => {
  const isTextSelected = editorHasValidSelection(editor);
  removePrefixBeforeCaret(editor);
  insertBankMessage(editor, data.item, isTextSelected);
};

/**
 * Insert URL into the editor
 * @param editor
 * @param data
 */
export const actionInsertUrl = (editor, data) => {
  const isTextSelected = data.noTags ? true : editorHasValidSelection(editor);
  if (!ReactEditor.isFocused(editor)) {
    focusEditor({ editor, atEnd: true });
  }
  removePrefixBeforeCaret(editor);
  insertResourceUrl(editor, data.url, isTextSelected);
};

/**
 * Insert "file resource" into the editor
 * @param editor
 * @param data
 */
export const actionInsertFileResource = (editor, data) => {
  removePrefixBeforeCaret(editor);
  insertFileTextToPrompt(
    editor,
    { file: data.resource, type: data.resource?.contentType },
    { focus: true }
  );
};

/**
 * Insert "variable" into the editor
 * @param editor
 * @param data
 */
export const actionInsertVariable = (editor, data) => {
  const node = {
    type: SLATE_TEXT_FORMATS.PROMPT_VARIABLE,
    children: [
      {
        title: data.variable.title,
        info: data.variable.info,
        text: data.variable.text,
        infoTooltip: data.variable.tooltip,
      },
    ],
  };

  removePrefixBeforeCaret(editor);
  insertVariable(editor, node);
};

/**
 * Insert "instruction" into the editor
 * @param editor
 * @param data
 */
export const actionInsertInstruction = (editor, data) => {
  removePrefixBeforeCaret(editor);
  insertInstruction(editor, data.instruction);
};

/**
 * Insert "external channel items" into the editor
 * @param editor
 * @param data
 */
export const actionInsertExternalChannelItems = (editor, data) => {
  insertExternalChannelItems(editor, data.items);
};

/**
 * Remove "file resource" from the editor
 * @param editor
 * @param data
 */
// TODO: support other resource file types
export const actionRemoveFileResource = (editor, data) => {
  const { contentType, label } = data;
  switch (contentType) {
    case RESOURCE_CONTENT_TYPE.image: {
      removeNodeFromPromptById(editor, PROMPT_NODE_ID.image, label);
      break;
    }

    case RESOURCE_CONTENT_TYPE.document:
    default: {
      removeNodeFromPromptById(editor, PROMPT_NODE_ID.document, label);
      break;
    }
  }
};
